<template>
	<div id="page_3">
		<div class="title">
			<p>QLink物联网方案特色</p>
			<p class="sub">设备端+云端+移动端，智能产品在这里无需开发</p>
		</div>
		<el-row :gutter="20">
		  <el-col :span="8" v-for="(item,i) in cardList" :key="i">
		  	<div class="card" @mouseover="update(item)" @mouseout="update(item)">
				<img :src="item.img"/>
				<div>
					<p>{{item.name}}</p>
					<p>{{item.desc}}</p>
					<p @click="fnToRouter('/404')">{{item.btn.name}}</p>
				</div>
		  	</div>
		  </el-col>
		</el-row>
	</div>
</template>
<script>
	
	export default {
		data() {
			return {
				cardList: [
					{
						"name": "物联网连接模块",
						"desc": "基于QLINK物联网模块，提供RS232、RS485、TTL、继电器接口，适用于任何微控制器、任何操作系统以及任何联网协议，开发者可将其应用于产品中，直接连接到QLINK云服务器。",
						"btn": {name:"QLINK物联网模块",url:""},
						"img": require('@/assets/img/home/3_1.png'),
						"img_hover":require("@/assets/img/home/3_1_hover.png"),
					}, {
						"name": "Qlink物联网服务器",
						"desc": "传统企业快速接入，轻松对接其他系统平台，安全稳定。提供完善的管理能力、商业智能以及大数据分析服务，用于管理海量的联网产品，云端全球化部署，远程控制、管理用户和管理设备。",
						"btn": {name:"QLINK云服务器",url:""},
						"img": require('@/assets/img/home/3_2.png'),
						"img_hover":require("@/assets/img/home/3_2_hover.png"),
					}, {
						"name": "物联网免开发软件",
						"desc": "QLINK的移动应用开发库包含丰富的API及丰富的设备UI模版，无需开发iOS和Android应用，自由选择也可个性制定应用来控制和管理基于QLINK的智能产品。",
						"btn": {name:"Qiot Pro APP",url:""},
						"img": require('@/assets/img/home/3_3.png'),
						"img_hover":require("@/assets/img/home/3_3_hover.png"),
					}
				]
			}
		},
		computed: {
		},
		methods: {
			update:function(item){
				var temp = item.img;
				item.img = item.img_hover;
				item.img_hover = temp;
			},
		},
		components: {			
		},
		created() {
		}
	}
</script>
<style lang="less">
	@import url("../../assets/common.less");
	
	#page_3{
		.page();
		& > .title{
			.page_title();
		}
		
		& > .el-row{
			overflow: hidden;
			position: absolute;
			top: 40vh;
			bottom: auto;
			left: 10vw;
			right: 10vw;
			width: 80vw;
			height:60vh;
			.card{
				padding: 30px;
				border: 1px solid #aaa;
				text-align: center;
				color: #8391a5;
				height: 45vh;
					position: relative;
				&:hover {
					border: 1px solid @theme-color;
				}
				&>img {
					width: 30%;
				}
				&>div {
					p:nth-of-type(1) {
						font-size: 1.2em;
						line-height: 2em;
					}
					p:nth-of-type(2) {
						text-align: left;
						font-size: 0.8em;
						line-height: 2em;
						text-indent: 2em;
					}
					p:nth-of-type(3) {
						font-size: 0.8em;
						line-height: 2em;
						color: @theme-color;
						cursor: pointer;
						
						position: absolute;
						bottom: 10px;
						left: 0;
						right: 0;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// page_3.vue?690ed739